export default "__VITE_ASSET__8832e498__"